export default __webpack_public_path__ + "static/media/HotelPic2.958427a0.jpg";